import FormControlLabel from '@mui/material/FormControlLabel'
import styled from '@mui/material/styles/styled'

export const OptionCheckbox = styled(FormControlLabel, {
  name: 'OptionCheckbox',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  margin: `0 0 0 ${theme.spacing(2.8)}`,
}))
